import React from "react";
import "../../styles/facilitatorKRAView.scss";
import { useEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import { toast } from "react-toastify";
import { getUser ,storeUser} from "../../utils/localStorage";
import { useHistory } from "react-router-dom";
import Spinner from "../../common/Spinner/Spinner";
import { Button } from "../../common/Button/Button";
import ReactDatePicker from "react-datepicker";

export default function MarkOutOfOfficeContainer(props)
{
    const history = useHistory();
    const ref = React.useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [fromDate, setfromDate] = useState();
    const [toDate, settoDate] = useState();
    const[activePage,setActivePage]=useState(""); 

    useEffect(() => {
        if (!getUser()) 
        {
			history.push("/login");
		}
        else
        {
            const user = getUser();
            if (user.out_of_office) 
            {
                setActivePage("MarkInOffice");
            }
            else
            {
                setActivePage("MarkOutOfOffice");
            } 
        }
	},[]);

    const dateAdjusted = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    // toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
                    toDateAdjusted.getTime() + (29.5 * 60 * 60 * 1000 - 1000)
                )
            );
        }
        return toDateAdjusted;
    }

    const dateAdjusted1 = (date) => {
        let toDateAdjusted;
        if (date) {
            toDateAdjusted = new Date(date);

            toDateAdjusted = new Date(
                toDateAdjusted.setTime(
                    // toDateAdjusted.getTime() + ((6 * 60 * 60 * 1000) - (0.5 * 60 * 60 * 1000)) 
                    toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
                )
            );
        }
        return toDateAdjusted;
    }


	const handleOutOfOffice= async () => {

		if(!fromDate)
		{
			toast("From date is required", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}

		if(!toDate)
		{
			toast("To date is required", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}

		setIsLoading(true);
		try {
            const user = getUser();
			const { email } = user;
			const data = await api
            .newDeactivateUser(email,true,dateAdjusted1(fromDate), dateAdjusted(toDate))
            .then((d) => {
                let updateddata={...user,out_of_office:true}
                storeUser(updateddata);
                setfromDate("");
			    settoDate("");
                setActivePage("MarkInOffice");
                toast("Successfully marked out of office", {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
            })
            .catch((error) => {
                toast("Something went wrong. Contact webadmin support.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            });			
		} catch (error) {
			//show error toast
		}
		setIsLoading(false);
	};

    const handleMarkInOffice = async () => {
		setIsLoading(true);
		try {
			const user = getUser();
			const { email } = user;
			// eslint-disable-next-line
			const data = await api
				.newMarkInOffice(email)
				.then((d) => {
                    let updateddata={...user,out_of_office:false}
                    storeUser(updateddata);
                    setfromDate("");
                    settoDate("");
                    setActivePage("MarkOutOfOffice");
					toast("Successfully marked in office", {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				})
				.catch((error) => {
					toast("Something went wrong. Contact webadmin support.", {
						autoClose: 5000,
						type: toast.TYPE.ERROR,
					});
				});
			// setoutOfOfficeOperation(!outOfOfficeOperation);
		} catch (error) {
			//show error toast
		}
		setIsLoading(false);
	};

    return(
        <>      
        {
            activePage==="MarkOutOfOffice"?
            (
                <div className={`${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="center-screen" />}
                    <div className="row"style={{marginTop:"10px"}}>
                        <div className="col-12 mark-out-office"> 
                            <label>
                                <b>Select Date Range</b>
                            </label>
                            <div class="inline-margin-userview">
                                <ReactDatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={fromDate}
                                    onChange={(date) =>setfromDate(date)}
                                    placeholderText="From Date"
                                    minDate={new Date()}
                                />
                                <ReactDatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selected={toDate}
                                    onChange={(date) =>settoDate(date)}
                                    placeholderText="To Date"
                                    minDate={new Date()}
                                />
                                <Button className="mark-out-office-inline-button" onClick={handleOutOfOffice}>Mark Out of Office</Button> 
                            </div>                            
                        </div>
                    </div>
                </div>
            )
            :
            activePage==="MarkInOffice"?
            (
                <div className={`${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="center-screen" />}
                    <div className="row"style={{marginTop:"10px"}}>
                        <div className="col-12 mark-out-office"> 
                                <Button className="mark-out-office-inline-button" onClick={handleMarkInOffice}>Mark In Office</Button> 
                        </div>
                    </div>
                </div>
            )
            :
            (
                ""
            )}
            
        </>
    );
}